/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CheckUsageDto, ItemsListItemDto } from '@gh/builder-shared-data';

export type ItemsListItem = ItemsListItemDto;
export type ItemsListCheckUsage = CheckUsageDto;

export const DEFAULT_ITEM_FILTER = { showDeleted: false, searchString: '' };
